<template>
  <div>
    <v-toolbar dense flat>
      <v-flex md4>
        <v-radio-group v-model="chartScaleType" :mandatory="true">
          <v-radio label="Linear" value="linear"></v-radio>
          <v-radio label="Logarithmic" value="logarithmic"></v-radio>
        </v-radio-group>
      </v-flex>
    </v-toolbar>
    <v-divider class="mt-2"></v-divider>
    <h1>{{ stateInfo.name }}</h1>

    <v-container grid-list-xl class="wide-page">
      <v-layout row wrap no-gutters>
        <v-flex md6>
          <line-chart :chartData="totalCasesChartDataObject" :options="totalCasesChartOptions"
                      v-if="getChartData('totalCases').length > 0"></line-chart>
        </v-flex>
        <v-flex md6>
          <line-chart :chartData="totalDeathsChartDataObject" :options="totalDeathsChartOptions"
                      v-if="getChartData('totalDeaths').length > 0"></line-chart>
        </v-flex>
      </v-layout>
    </v-container>

    <v-container grid-list-xl class="wide-page mt-4">
      <v-layout row wrap no-gutters>
        <v-flex md6>
          <line-chart :chartData="newCasesChartDataObject" :options="newCasesChartOptions"
                      v-if="getChartData('newCases').length > 0"></line-chart>
        </v-flex>
        <v-flex md6>
          <line-chart :chartData="newDeathsChartDataObject" :options="newDeathsChartOptions"
                      v-if="getChartData('newDeaths').length > 0"></line-chart>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import LineChart from '../subcomponents/LineChart.vue'

export default {
  name: 'State',
  components: { LineChart },
  props: {
    msg: String
  },
  data() {
    return {
      totalDeaths: [],
      totalDeathsLog: [],
      totalCases: [],
      totalCasesLog: [],
      newDeaths: [],
      newDeathsLog: [],
      newCases: [],
      newCasesLog: [],
      chartScaleTypes: [
        { name: 'Linear', value: 'linear' },
        { name: 'Logarithmic', value: 'logarithmic' }
      ],
      chartScaleType: 'linear',
      stateData: {},
      chartData: {
        totalCases: [],
        totalDeaths: [],
        newCases: [],
        newDeaths: []
      },
      headers: ['date', 'state', 'flips', 'cases', 'deaths'],
    }
  },
  computed: {
    stateInfo() {
      return this.$store.getters.getListOfStates.find(state => state.propName === this.$route.params.state)
    },
    totalCasesChartOptions() {
      let context = this
      return {
        maintainAspectRatio: false,
        legend: {
          display: false
        },
        title: {
          display: true,
          text: 'Total Cases',
          fontSize: 18
        },
        scales: {
          xAxes: [{
            gridLines: {
              color: 'white',
              display: false,
            },
            ticks: {
              display: true,
              callback: function(value, index, values) {
                if (index % 7 === 0) {
                  return context.toChartDate(value)
                } else {
                  return ''
                }
              }
            }
          }],
          yAxes: [{
            type: context.chartScaleType,
            scaleLabel: {
              display: false,
              labelString: 'Cases',
              fontSize: 16,
            },
            gridLines: {
              color: '#e3e3e3',
              display: true,
            },
            ticks: {
              display: true, 
              beginAtZero: true,
              callback: function(value, index, values) {
                return context.numberWithCommas(value)
              }
            },
            afterBuildTicks: function(chart){
              context.afterBuildTicksFunction(chart)
            }
          }]
        }
      }
    },
    newCasesChartOptions() {
      let context = this
      return {
        maintainAspectRatio: false,
        legend: {
          display: false
        },
        title: {
          display: true,
          text: 'New Cases',
          fontSize: 18
        },
        scales: {
          xAxes: [{
            gridLines: {
              color: 'white',
              display: false,
            },
            ticks: {
              display: true,
              callback: function(value, index, values) {
                if (index % 7 === 0) {
                  return context.toChartDate(value)
                } else {
                  return ''
                }
              }
            }
          }],
          yAxes: [{
            type: context.chartScaleType,
            scaleLabel: {
              display: false,
              labelString: 'Percentage',
              fontSize: 16,
            },
            gridLines: {
              color: '#e3e3e3',
              display: true
            },
            ticks: {
              display: true,
              callback: function(value, index, values) {
                return context.numberWithCommas(value)
              }
            },
            afterBuildTicks: function(chart){
              context.afterBuildTicksFunction(chart)
            }
          }]
        },
      }
    }, 
    totalDeathsChartOptions() {
      let context = this
      return {
        maintainAspectRatio: false,
        legend: {
          display: false
        },
        title: {
          display: true,
          text: 'Total Deaths',
          fontSize: 18
        },
        scales: {
          xAxes: [{
            gridLines: {
              color: 'white',
              display: false,
            },
            ticks: {
              display: true,
              callback: function(value, index, values) {
                if (index % 7 === 0) {
                  return context.toChartDate(value)
                } else {
                  return ''
                }
              }
            }
          }],
          yAxes: [{
            type: context.chartScaleType,
            scaleLabel: {
              display: false,
              labelString: 'Deaths',
              fontSize: 16,
            },
            gridLines: {
              color: '#e3e3e3',
              display: true
            },
            ticks: {
              display: true,
              beginAtZero: true,
              callback: function(value, index, values) {
                return context.numberWithCommas(value)
              }
            },
            afterBuildTicks: function(chart){
              context.afterBuildTicksFunction(chart)
            }
          }]
        }
      }
    },
    newDeathsChartOptions() {
      let context = this
      return {
        maintainAspectRatio: false,
        legend: {
          display: false
        },
        title: {
          display: true,
          text: 'New Deaths',
          fontSize: 18
        },
        scales: {
          xAxes: [{
            gridLines: {
              color: 'white',
              display: false,
            },
            ticks: {
              display: true,
              callback: function(value, index, values) {
                if (index % 7 === 0) {
                  return context.toChartDate(value)
                } else {
                  return ''
                }
              }
            },
          }],
          yAxes: [{
            type: context.chartScaleType,
            scaleLabel: {
              display: false,
              labelString: 'Percentage',
              fontSize: 16,
            },
            gridLines: {
              color: '#e3e3e3',
              display: true
            },
            ticks: {
              display: true,
              callback: function(value, index, values) {
                return context.numberWithCommas(value)
              }
            },
            afterBuildTicks: function(chart) {
              context.afterBuildTicksFunction(chart)
            }
          }]
        },
      }
    },
    totalCasesChartDataObject() {
      return {
        labels: Object.keys(this.stateData),
        datasets: [
          {
            type: 'line',
            label: 'Cases',
            borderColor: 'rgba(55,55,55,1)',
            backgroundColor: 'rgba(225,185,55,0.5)',
            data: this.getChartData('totalCases')
          }
        ]
      }
    },
    newCasesChartDataObject() {
      return {
        labels: Object.keys(this.stateData),
        datasets: [
          {
            type: 'line',
            label: 'Cases',
            borderColor: 'rgba(55,55,55,1)',
            backgroundColor: 'rgba(225,185,55,0.5)',
            data: this.getChartData('newCases')
          }
        ]
      }
    },
    totalDeathsChartDataObject() {
      return {
        labels: Object.keys(this.stateData),
        datasets: [
          {
            type: 'line',
            label: 'Total Deaths',
            borderColor: 'rgba(55,55,55,1)',
            backgroundColor: 'rgba(225,85,55,0.5)',
            data: this.getChartData('totalDeaths')
          }
        ]
      }
    },
    newDeathsChartDataObject() {
      return {
        labels: Object.keys(this.stateData),
        datasets: [
          {
            type: 'line',
            label: 'New Deaths',
            borderColor: 'rgba(55,55,55,1)',
            backgroundColor: 'rgba(225,85,55,0.5)',
            data: this.getChartData('newDeaths')
          },
        ]
      }
    },
  },
  created() {
    this.stateData = this.$store.getters.getCovidData[this.$route.params.state]
    if (this.stateData !== {} & typeof this.stateData !== 'undefined') {
      this.prepareChartData()
    }
    document.title = `Covid-19 Data Visualizer | ${this.stateInfo.name}`
  },
  watch: {
    '$store.getters.getCovidData': function(newValue) {
      if (newValue !== {}) {
        this.stateData = this.$store.getters.getCovidData[this.$route.params.state]
        this.prepareChartData()
      }
    },
    '$route.params.state': function(newValue) {
      this.stateData = this.$store.getters.getCovidData[newValue]
      document.title = `Covid-19 Data Visualizer | ${this.stateInfo.name}`
      this.prepareChartData()
    }
  },
  methods: {
    getChartData(chartName) {
      return this.chartData[chartName]
    },
    afterBuildTicksFunction(chart){
      var maxTicks = 20
      var maxLog = Math.log(chart.ticks[0])
      var minLogDensity = maxLog / maxTicks

      var ticks = []
      var currLog = -Infinity
      chart.ticks.reverse().forEach(function(tick){
        var log = Math.max(0, Math.log(tick))
        if (log - currLog > minLogDensity){
          ticks.push(tick)
          currLog = log
        }
      })
      chart.ticks = ticks
    },
    changeChartScaleType() {
      this.prepareChartData()
    },
    prepareChartData() {
      let totalDeaths = []
      let newDeaths = [0]
      let totalCases = []
      let newCases = [0]
      let labels = Object.keys(this.stateData)

      labels.forEach(label => {
        let labelIndex = labels.indexOf(label)
        let deaths = this.stateData[label].deaths
        let cases = this.stateData[label].cases

        totalDeaths.push(deaths)
        totalCases.push(cases)

        let newDeathsCount = 0
        let newCasesCount = 0
        if (labelIndex !== 0) {
          let previousLabel = labels[labelIndex - 1]
          let previousDeaths = this.stateData[previousLabel].deaths
          let previousCases = this.stateData[previousLabel].cases
          if (previousDeaths !== 0) {
            let newDeathsCount = this.stateData[label].deaths - previousDeaths
            newDeaths.push(newDeathsCount)
          } else {
            newDeaths.push(0)
          }

          if (previousCases !== 0) {
            let newCasesCount = this.stateData[label].cases - previousCases
            newCases.push(newCasesCount)
          } else {
            newCases.push(0)
          }

        } else {
          this.newDeaths.push(0)
          this.newCases.push(0)
        }
      })
      this.chartData.totalDeaths = totalDeaths
      this.chartData.totalCases = totalCases
      this.chartData.newDeaths = newDeaths
      this.chartData.newCases = newCases
    },
    round(num, places) {
      const multiplier = Math.pow(10, places)
      return Math.round(num * multiplier) / multiplier
    },
    numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    toChartDate(dateStr) {
      let d = new Date(dateStr)
      return d.toDateString().substring(4, 10)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
